import { render, staticRenderFns } from "./EntradaMultiForm.vue?vue&type=template&id=0773f194"
import script from "./EntradaMultiForm.vue?vue&type=script&lang=js"
export * from "./EntradaMultiForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports